module.exports = __webpack_public_path__ + "static/media/o3.fef35ffc.svg";